import { useState } from 'react';
import { useDispatch } from 'react-redux';

import { updateLimitsModal } from '~/components/account/ducks';

const useIframeLoader = () => {
	const [iframeLoaded, setIframeLoaded] = useState(false);
	const dispatch = useDispatch();

	const handleIframeLoad = () => setIframeLoaded(true);
	const handleIframeUnload = (option = {}) => {
		setIframeLoaded(false);
		dispatch(updateLimitsModal(false, option));
	};

	const closeIframe = () => setIframeLoaded(false);

	return { iframeLoaded, handleIframeLoad, handleIframeUnload, closeIframe };
};

export default useIframeLoader;
